import { type TimeRange, TimeRangeType } from "Infrastructure/ApiZfp/Schema";
import { addMonths, differenceInCalendarMonths, startOfMonth } from "date-fns";

// The retirement age is kept in months, not years: a retirement date picked as a month only survives a save/reload
// if the age it is stored as is just as precise. The day of birth is deliberately ignored — someone born 15. 12. 1993
// retires "at 65" in 12/2058, even though on 1. 12. 2058 they are two weeks short of their birthday.

export const retirementAgeMonthsToDate = (birthDate: Date, ageMonths: number) => addMonths(startOfMonth(birthDate), ageMonths);

export const retirementDateToAgeMonths = (birthDate: Date, retirementDate: Date) => differenceInCalendarMonths(retirementDate, birthDate);

export const ageMonthsToYears = (ageMonths: number) => Math.floor(ageMonths / 12);

export const retirementStartAgeToMonths = (retirementStartAge: TimeRange | null | undefined) => {
  if (!retirementStartAge) return undefined;
  return retirementStartAge.type === TimeRangeType.month ? retirementStartAge.value : retirementStartAge.value * 12;
};
